
import { defineComponent, ref, watch, computed, PropType, nextTick } from "vue";
import Button from "@/components/UI/Button.vue";

export default defineComponent({
  name: "CheckboxList",
  components: { Button },

  props: {
    text: String,
    choiceAnswer: Array,
    currentLang: String,
    customAnswer: Boolean,
    customTextAnswer: String,
    verticalLayout: Boolean,
    index: Number,
    type: {
      type: String as PropType<"ONE_PAGE" | undefined>,
      required: false,
    },
  },

  emits: ["answersFields", "next-question"],

  setup(props, { emit }) {
    const checkbox = ref<any[]>([]);
    const customAnswerS = ref<string>("");

    const centerNum = computed(() => {
      let arrLength = props.choiceAnswer?.length || 0;
      return Math.floor(arrLength / 2);
    });

    const answerChunk = computed(() => {
      const newArray = [];
      if (props.choiceAnswer?.length && props.choiceAnswer.length > 5) {
        for (let i = 0; i < props?.choiceAnswer.length; i += centerNum.value) {
          newArray.push(props.choiceAnswer.slice(i, i + centerNum.value));
        }
      } else {
        newArray.push(props.choiceAnswer);
      }
      return newArray;
    });

    watch(
      () => checkbox.value,
      async (v: any) => {
        if (props.type === "ONE_PAGE") return;
        await nextTick();

        let answer: any[] = [];
        checkbox.value.forEach((el: { choiceRu: string }) =>
          answer.push(el.choiceRu)
        );

        emit("answersFields", props.index, {
          myltiAnswer: answer,
          customAnswer: customAnswerS.value,
        });
      }
    );

    watch(
      () => customAnswerS.value,
      async (v: string) => {
        if (props.type === "ONE_PAGE") return;
        await nextTick();

        let answer: any[] = [];
        checkbox.value.forEach((el: { choiceRu: string }) =>
          answer.push(el.choiceRu)
        );

        emit("answersFields", props.index, {
          myltiAnswer: answer,
          customAnswer: v,
        });
      }
    );

    const sendAnswer = () => {
      let answer: any[] = [];
      checkbox.value.forEach((el: { choiceRu: string }) =>
        answer.push(el.choiceRu)
      );
      console.log(checkbox.value);
      emit("answersFields", props.index, {
        myltiAnswer: answer,
        customAnswer: customAnswerS.value,
      });

      emit("next-question");
    };

    return {
      checkbox,
      customAnswerS,
      centerNum,
      answerChunk,
      sendAnswer,
    };
  },
});
